export const Translations_FR = {
	footer: {
		join: "Participer à la discussion maintenant. Pas d'app ni d'inscription obligatoire.",
		climate: "Une Discussion Positive pour le Climat.",
		tree: "Cet arbre a été planté.",
		start: "Démarrer les dicussions video gratuitement.",
	},
};
